import { Configuration } from 'ohzi-core';
import Utils from '/js/core/Utils';

import ApplicationView from '../common/ApplicationView';
import CollapsibleContainer from '../common/CollapsibleContainer';

/**
 *  @class UavView
 *  @description This class is responsible for the display of the UAV controls and status
 */

// This represents the drone panel that contains the UAV status and controls
class UavView extends ApplicationView
{
  constructor(app)
  {
    super('drone', $('.drone'));

    this.app = app;
    this.alt_change_request_time = 0;
    this.is_opened = false;
    this.follow_state = false;
    this.sim_enable_state = true;
    this.beam_enable_state = true;
    this.nested_click = false;

    this.control_mode = 'guided';

    // PyMavlink compatible
    this.mavFlightModes = {
      0: 'Stabilize',
      1: 'Acro',
      2: 'AltHold',
      3: 'Auto',
      4: 'Guided',
      5: 'Loiter',
      6: 'RTL',
      7: 'Circle',
      9: 'Land',
      11: 'Drift',
      13: 'Sport',
      14: 'Flip',
      15: 'AutoTune',
      16: 'PosHold',
      17: 'Brake',
      18: 'Throw',
      19: 'AvoidAdbs',
      20: 'GuidedNoGps',
      21: 'SmartRtl',
      22: 'FlowHold',
      23: 'Follow',
      24: 'Zigzag',
      25: 'SystemId',
      26: 'AutoRotate',
      27: 'AutoRtl',
      28: 'Turtle',
      100: 'Unknown'
    };

    this.mavSeverity = {
      0: 'Emergency',
      1: 'Alert',
      2: 'Critical',
      3: 'Error',
      4: 'Warning',
      5: 'Notice',
      6: 'Info',
      7: 'Debug'
    };

    this.gpsFixType = {
      0: 'No GPS',
      1: 'No Fix',
      2: '2D Fix',
      3: '3D Fix',
      4: 'DGPS',
      5: 'RTK_FLOAT',
      6: 'RTK_FIXED',
      7: 'Static',
      7: 'PPP'
    };
  }

  start()
  {
    this.drone_container = $('.drone__container');
    this.close_button = $('.drone__buttons-close');
    this.open_button = $('.drone__buttons-open');
    this.menu_handle = $('.drone__handle');

    if (true)
    {
      this.enable_view();
    }
    else
    {
      this.disable_view();
    }

    this.uav_status_el = this.container.find('.drone__body-status')[0];
    this.uav_drone_header_state_el = document.querySelector('.drone__status-header-state');
    this.uav_messages_container = this.container.find('.drone__body-messages');
    this.uav_messages_el = this.container.find('.drone__body-messages__body')[0];

    this.btn_system_connect = $('.drone__button-system.system-connect')[0];
    this.btn_system_connect_text = $('.drone__button-system.system-connect').find('.drone__button-text')[0];
    this.btn_sitl_reset = $('.drone__button-system.sitl-reset')[0];

    this.btn_command_atof = $('.drone__button.command-atof')[0];
    this.btn_command_land = $('.drone__button.command-land')[0];
    this.btn_command_rtl = $('.drone__button.command-rtl')[0];
    this.btn_command_tof = $('.drone__button.command-tof')[0];
    this.btn_command_arm = $('.drone__button.command-arm')[0];
    this.btn_command_disarm = $('.drone__button.command-disarm')[0];
    this.btn_mode_guided = $('.drone__button.mode-guided')[0];
    this.btn_mode_taglock = $('.drone__button.mode-taglock')[0];
    this.btn_mode_brake = $('.drone__button.mode-brake')[0];
    this.btn_orientation_free = $('.drone__button.orientation-free')[0];
    this.btn_orientation_north = $('.drone__button.orientation-north')[0];
    this.btn_orientation_gcs = $('.drone__button.orientation-gcs')[0];
    this.btn_follow = $('.drone__button.set-follow')[0];

    this.btn_prec_land_res_l = $('.precision-landing__set-res-l')[0];
    this.btn_prec_land_res_h = $('.precision-landing__set-res-h')[0];

    this.input_toggle_sim_enable = document.querySelector('.drone__options-item--toggle-sim');
    this.input_toggle_beam_enable = document.querySelector('.drone__options-item--toggle-beam');
    this.input_orientation_manual_yaw = document.querySelector('.drone__body-inputs__orientation-manual-yaw');

    this.__toggle_switch_elem(this.btn_mode_guided, true);
    this.__toggle_switch_elem(this.btn_orientation_free, true);

    this.altSlider = document.getElementById('uav-alt-slider');
    this.altValueFt = document.getElementById('uav-alt-value-ft');
    this.altValueM = document.getElementById('uav-alt-value-m');

    // Update slider fill CSS variable
    this.update_slider_fill = function()
    {
      const min = parseFloat(this.altSlider.min) || 0;
      const max = parseFloat(this.altSlider.max) || 100;
      const value = parseFloat(this.altSlider.value) || min;
      const percentage = ((value - min) / (max - min)) * 100;
      this.altSlider.style.setProperty('--slider-fill', `${percentage}%`);
    };

    // Initialize slider fill
    this.update_slider_fill();

    this.altSlider.addEventListener('input', function()
    {
      this.update_slider_fill();
      this.set_slider_alt(this.altSlider.value);
    }.bind(this));

    // Listen for changes to the Manual Yaw value to immediately change if Manual Yaw is set
    this.input_orientation_manual_yaw.addEventListener('change', function(e)
    {
      if (this.app.uav_manager?.orientation_mode == 'manual')
      {
        // this.app.uav_manager.cmd_orientation_mode('manual', this.input_orientation_manual_yaw.value);
      }
    }.bind(this));

    this.uav_controller_container = new CollapsibleContainer('UAV Controller', $('.drone__body-uav-controller__container'));
    this.uav_controller_container.set_status_label_prefix(' Backend Online: ');
    this.truck_cover_container = new CollapsibleContainer('Truck Bed Cover', $('.drone__body-truck-cover__container'));
    this.precision_landing_container = new CollapsibleContainer('Precision Landing', $('.drone__body-hud__container'), true);
    this.prec_land_connection_status_el = this.precision_landing_container.container.find('.menu__collapsable-container__body-connection-status')[0];
    this.prec_land_resolution_el = this.precision_landing_container.container.find('.precision-landing__resolution-value')[0];

    this.truck_cover_action_in_progress = false;

    // Handle mouseup anywhere on the document to detect if mouse down was on button but then user moves off
    document.addEventListener('mouseup', (event) =>
    {
      if (this.truck_cover_action_in_progress)
      {
        this.truck_cover_action_in_progress = false;
        console.log('Detected button release (off button) Send truck cover stop');
        if (this.app.uav_manager.api_truck_cover_ws) this.app.uav_manager.api_truck_cover_ws.request_stop();
      }
    });

    if (!Configuration.is_mobile && !this.app.mode_multi_camera)
    {
      // Disable by default. Check uiShowOptions parameters from Tracker App
      this.container.css('width', localStorage.getItem('drone_width'));
    }

    this.menu_handle.on('mousedown touchstart', this.__on_mouse_down.bind(this));

    this.demo_load_state();
  }

  demo_load_state(sim = true)
  {
    const uav_option_enabled = true;
    const truck_cover_option_enabled = true;
    const truck_cover_online = true;

    this.enable_view();

    if (uav_option_enabled)
    {
      this.enable_uav_view();
    }
    else
    {
      this.disable_uav_view();
    }

    if (truck_cover_option_enabled)
    {
      this.enable_truck_cover_view();

      // console.log(`Truck Motors API WebSocket status changed: ${status}`);
      if (truck_cover_online)
      {
        this.truck_cover_container.set_online();
      }
      else
      {
        this.truck_cover_container.set_offline();
      }
    }
    else
    {
      this.disable_truck_cover_view();
    }

    // this.update_precision_landing_connection_status(parsedMessage);

    const data = {
      connected: true,
      flight_mode: 4,
      alt: 0.007,
      alt_abs: 276.01,
      armed: false,
      arming: false,
      base_platform: {
        truck_bed_closed_state: true,
        truck_bed_closing_state: false,
        truck_bed_opened_state: false,
        truck_bed_opening_state: false
      },
      battery: 12.587,
      battery_remaining: 100,
      gps_cog: 0,
      gps_fix_type: 6,
      gps_hdop: 121,
      gps_num_sats: 10,
      gps_vdop: 200,
      gps_vel: 0,
      heading: 176.43,
      home_alt: null,
      home_alt_abs: 276.01,
      home_lat: 39.418344,
      home_lon: -76.6141521,
      in_air: false,
      last_heartbeat_ms: 1762745208397,
      lat: 39.4183429,
      lon: -76.6141505,
      name: 'sitl',
      pitch: -0.24277624592290004,
      roll: -0.25080113122828324,
      taglock: {
        selected_taglock: null
      },
      target_location_alt_abs: null,
      target_location_latitude: null,
      target_location_longitude: null,
      type: 'uav_telemetry',
      yaw: 176.42665494088075
    };

    if (sim)
    {
      this.uav_controller_container.set_online();
      this.precision_landing_container.set_online();
      this.truck_cover_container.set_online();
      this.update_status(data);
    }
    else
    {
      data.connected = false;
      this.uav_controller_container.set_offline();
      this.precision_landing_container.set_offline();
      this.truck_cover_container.set_offline();
      this.disable_truck_cover_view();
    }

    // Functions that can be called from outside this class
    this.set_slider_alt(40.7);
    this.set_orientation('free', false);
    this.set_orientation_yaw(183);
    this.update_control_mode_button_state('guided', true);

    this.add_message('Frame: QUAD', 6);
    this.add_message('Version: V4.0.3', 1);
    this.add_message('Takeoff', 4);
  }

  update()
  {
    // Monitor if any menus are open then move the drone icon
    if (this.app.pharos_view.is_opened)
    {
      this.open_button.css('right', '-470px');
    }
    else if (this.app.menu_view.is_opened)
    {
      this.open_button.css('right', '-170px');
    }
    else
    {
      this.open_button.css('right', '-100px');
    }

    if (this.is_opened)
    {
      const now_ms = new Date().getTime();

      if (this.alt_change_request_time != 0 && (now_ms - this.alt_change_request_time > 500))
      {
        // Altitude change request has finished updating slider
        this.alt_change_request_time = 0;
        this.app.uav_manager.request_alt_change(this.altSlider.value);
      }
    }
    else
    {
      this.alt_change_request_time = 0;
    }

    if (true)
    {
      this.truck_cover_container.set_online();
    }
    else
    {
      this.truck_cover_container.set_offline();
    }

    this.prec_land_resolution_el.innerHTML = 'Stream Res: N/A';
  }

  enable_view()
  {
    this.drone_container.removeClass('hidden');
  }

  disable_view()
  {
    this.drone_container.addClass('hidden');
  }

  enable_uav_view()
  {
    this.uav_controller_container.show();
    this.uav_controller_container.open();
    this.precision_landing_container.show();
    this.uav_messages_container.removeClass('hidden');
  }

  disable_uav_view()
  {
    this.uav_controller_container.hide();
    this.precision_landing_container.hide();
    this.uav_messages_container.addClass('hidden');
  }

  enable_truck_cover_view()
  {
    if (this.truck_cover_container) this.truck_cover_container.show();
  }

  disable_truck_cover_view()
  {
    if (this.truck_cover_container) this.truck_cover_container.hide();
  }

  // Closes the menu panel
  close()
  {
    if (!this.app.menu_options_view.keep_menu_visible)
    {
      this.is_opened = false;
      this.container.addClass('closed');

      if (this.app.menu_options_view.show_thumbnail_video)
      {
        // MenuCameraManager.pause_all_cameras();
        // MenuCameraManager.stop_all_cameras();
      }
    }
  }

  // Opens the menu panel
  open()
  {
    // Close other menus
    this.app.pharos_view.close();
    this.app.menu_view.close();

    this.is_opened = true;
    this.container.removeClass('closed');
  }

  // Called by UI (drone.pug) when the user clicks the button down
  on_truck_cover_open_press()
  {
    console.log('[on_truck_cover_open_press]');
    this.truck_cover_action_in_progress = true;
    // Do more actions here
  }

  // Called by UI (drone.pug) when the user clicks the button down
  on_truck_cover_close_press()
  {
    console.log('[on_truck_cover_close_press]');
    this.truck_cover_action_in_progress = true;
    // Do more actions here
  }

  // Called by UI (drone.pug) when the user released button press
  on_truck_cover_btn_release()
  {
    console.log('[on_truck_cover_btn_release]');
    this.truck_cover_action_in_progress = false;
    // Do more actions here
  }

  // Called by UI (drone.pug) when the user clicks the button
  on_truck_cover_stop()
  {
    console.log('[on_truck_cover_stop]');
    this.truck_cover_action_in_progress = false;
    // Do more actions here
  }

  // Called by UI (drone.pug) when the user clicks the button
  toggle_sim_enable()
  {
    this.sim_enable_state = !this.sim_enable_state;

    console.log(`[toggle_sim_enable] sim_enable_state: ${this.sim_enable_state}`);

    if (this.sim_enable_state)
    {
      // this.__toggle_switch_elem(this.input_toggle_sim_enable, true);
      $(this.btn_sitl_reset).removeClass('hidden');
      // Do more actions here
    }
    else
    {
      // this.__toggle_switch_elem(this.input_toggle_sim_enable, false);
      $(this.btn_sitl_reset).addClass('hidden');
      // Do more actions here
    }
    this.demo_load_state(this.sim_enable_state);
  }

  // Called by UI (drone.pug) when the user clicks the button
  toggle_beam_enable()
  {
    console.warn('[toggle_beam_enable]');
    this.beam_enable_state = !this.beam_enable_state;

    // if (this.beam_enable_state)
    // {
    //   this.__toggle_switch_elem(this.input_toggle_beam_enable, true);
    // }
    // else
    // {
    //   this.__toggle_switch_elem(this.input_toggle_beam_enable, false);
    // }
  }

  // Called by UI (drone.pug) when the user clicks the button
  system_connect()
  {
    this.system_connect_state = !this.system_connect_state;
    if (this.system_connect_state)
    {
      // Do more actions here
      this.set_system_connected_state(true);
    }
    else
    {
      // Do more actions here
      this.set_system_connected_state(false);
    }
  }

  set_system_connected_state(state)
  {
    this.system_connect_state = state;

    if (state)
    {
      this.__toggle_switch_elem(this.btn_system_connect, true);
      this.btn_system_connect_text.innerHTML = 'Disconnect';
    }
    else
    {
      this.__toggle_switch_elem(this.btn_system_connect, false);
      this.btn_system_connect_text.innerHTML = 'Connect';
    }
  }

  // Called by UI (drone.pug) when the user clicks the button
  sitl_reset()
  {
    console.log('[sitl_reset]');
    // Do more actions here
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_command(command)
  {
    console.log(`[set_command] command: ${command}`);
    this.__toggle_switch_elem(this.btn_command_atof, false);
    this.__toggle_switch_elem(this.btn_command_land, false);
    this.__toggle_switch_elem(this.btn_command_rtl, false);
    this.__toggle_switch_elem(this.btn_command_tof, false);
    this.__toggle_switch_elem(this.btn_command_arm, false);
    this.__toggle_switch_elem(this.btn_command_disarm, false);

    switch (command)
    {
    case 'atof':
      // Send Arm and Takeoff command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_atof, true);
      break;
    case 'land':
      // Send Land command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_land, true);
      break;
    case 'rtl':
      // Send RTL command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_rtl, true);
      break;
    case 'tof':
      // Send Takeoff command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_tof, true);
      break;
    case 'arm':
      // Send Arm command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_arm, true);
      break;
    case 'disarm':
      // Send Disarm command
      // Do more actions here
      this.__toggle_switch_elem(this.btn_command_disarm, true);
      break;
    default:
      //
      console.log(`[set_command] Command '${command}' not handled`);
    }
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_orientation(command, send_cmd = true)
  {
    // console.log(`[set_orientation] command: ${command}`);
    this.__toggle_switch_elem(this.btn_orientation_free, false);
    this.__toggle_switch_elem(this.btn_orientation_north, false);
    this.__toggle_switch_elem(this.btn_orientation_gcs, false);

    switch (command)
    {
    case 'free':
      // Set orientation mode to Free
      this.__toggle_switch_elem(this.btn_orientation_free, true);
      break;
    case 'north':
      // Set orientation mode to North
      this.__toggle_switch_elem(this.btn_orientation_north, true);
      break;
    case 'manual':
      // Set orientation mode to Manual i.e a custom defined yaw
      this.__toggle_switch_elem(this.btn_orientation_manual, true);
      manual_yaw = this.input_orientation_manual_yaw.value;
      break;
    case 'gcs':
      // Set orientation mode to GCS
      this.__toggle_switch_elem(this.btn_orientation_gcs, true);
      break;
    default:
      console.warn(`[set_orientation] Orientation '${command}' not handled`);
      return;
    }
    if (send_cmd)
    {
      // Do more actions here
    }
  }

  // Called when status API updates
  set_orientation_yaw(yaw)
  {
    if (yaw)
    {
      this.input_orientation_manual_yaw.value = yaw;
    }
    else
    {
      console.log('[set_orientation_yaw] Orientation yaw isn\'t valid, set to 0');
      this.input_orientation_manual_yaw.value = 0;
    }
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_mode_auto(send_cmd = true)
  {
    this.control_mode = 'auto';
    if (send_cmd) this.app.uav_manager.cmd_control_mode('auto');
    this.__toggle_switch_elem(this.btn_mode_auto, true);
    this.__toggle_switch_elem(this.btn_mode_guided, false);
    this.__toggle_switch_elem(this.btn_mode_taglock, false);
    this.__toggle_switch_elem(this.btn_mode_brake, false);
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_mode_guided(send_cmd = true)
  {
    this.control_mode = 'guided';
    // if (send_cmd) // Do more actions here
    this.__toggle_switch_elem(this.btn_mode_guided, true);
    this.__toggle_switch_elem(this.btn_mode_taglock, false);
    this.__toggle_switch_elem(this.btn_mode_brake, false);
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_mode_taglock(send_cmd = true)
  {
    this.control_mode = 'taglock';
    // if (send_cmd) // Do more actions here
    this.__toggle_switch_elem(this.btn_mode_guided, false);
    this.__toggle_switch_elem(this.btn_mode_taglock, true);
    this.__toggle_switch_elem(this.btn_mode_brake, false);
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_mode_brake(send_cmd = true)
  {
    this.control_mode = 'brake';
    // if (send_cmd) // Do more actions here
    this.__toggle_switch_elem(this.btn_mode_guided, false);
    this.__toggle_switch_elem(this.btn_mode_taglock, false);
    this.__toggle_switch_elem(this.btn_mode_brake, true);
  }

  update_control_mode_button_state(control_mode, update_control_mode = false)
  {
    if (update_control_mode)
    {
      this.control_mode = control_mode;
    }
    switch (control_mode)
    {
    case 'guided':
      this.__toggle_switch_elem(this.btn_mode_guided, true);
      this.__toggle_switch_elem(this.btn_mode_taglock, false);
      this.__toggle_switch_elem(this.btn_mode_brake, false);
      break;
    case 'taglock':
      this.__toggle_switch_elem(this.btn_mode_guided, false);
      this.__toggle_switch_elem(this.btn_mode_taglock, true);
      this.__toggle_switch_elem(this.btn_mode_brake, false);
      break;
    case 'brake':
      this.__toggle_switch_elem(this.btn_mode_guided, false);
      this.__toggle_switch_elem(this.btn_mode_taglock, false);
      this.__toggle_switch_elem(this.btn_mode_brake, true);
      break;
    default:
      // Control mode is currently other i.e land / RTL etc.
      this.__toggle_switch_elem(this.btn_mode_guided, false);
      this.__toggle_switch_elem(this.btn_mode_taglock, false);
      this.__toggle_switch_elem(this.btn_mode_brake, false);
    }
  }

  // Called by UI (drone.pug) when the user clicks the button
  set_follow()
  {
    const state = !this.follow_state;

    // Do more actions here
    this.set_follow_button_state(state);
  }

  set_follow_button_state(state)
  {
    this.follow_state = state;
    this.__toggle_switch_elem(this.btn_follow, this.follow_state);
  }

  get_slider_alt()
  {
    // Convert feet to meters
    // let meters = this.altSlider.value * 0.3048;
    // console.log(`[get_slider_alt] slider: ${this.altSlider.value} ft, ${meters}m`);
    console.log(`[get_slider_alt] slider: ${this.altSlider.value}m`);
    return this.altSlider.value;
  }

  set_slider_alt(alt)
  {
    this.altSlider.value = alt;
    this.update_slider_fill();

    const feet = this.altSlider.value / 0.3048;
    this.altValueFt.textContent = `${feet.toFixed(0)} FT`;
    this.altValueM.textContent = `${this.altSlider.value} m`;

    this.alt_change_request_time = new Date().getTime();
  }

  // Called by UI (drone.pug) when the user clicks the button
  btn_res_l()
  {
    this.set_uav_resolution(false);
  }

  // Called by UI (drone.pug) when the user clicks the button
  btn_res_h()
  {
    this.set_uav_resolution(true);
  }

  set_res_btn_state(res_high)
  {
    this.video_res_h = res_high;

    this.__toggle_switch_elem(this.btn_prec_land_res_l, !this.video_res_h);
    this.__toggle_switch_elem(this.btn_prec_land_res_h, this.video_res_h);
  }

  set_uav_resolution(res_high)
  {
    const res = false;
    // Do more actions here
    return res;
  }

  create_status_item(title, text)
  {
    const item = document.createElement('div');
    item.classList.add('drone__body-status-item');
    const item_title = document.createElement('div');
    const item_text = document.createElement('div');

    item_title.textContent = title;
    item_text.textContent = text;

    item.appendChild(item_title);
    item.appendChild(item_text);

    return item;
  }

  toggle_body_status()
  {
    const chevron_icon = document.querySelector('.drone__status-header-icon');
    chevron_icon.classList.toggle('drone__status-header-icon--up');
    this.uav_status_el.classList.toggle('drone__body-status--closed');
  }

  update_status(status)
  {
    if (status && Utils.is_json(status))
    {
      const content_keys = Object.keys(status);

      if (status.connected)
      {
        this.uav_status_el.innerHTML = '';

        const flight_mode_item = this.create_status_item('Flight Mode:', `${this.mavFlightModes[status.flight_mode]} (${status.flight_mode})`);
        const state_item = this.create_status_item('State:', `${status.armed ? 'Armed' : 'Disarmed'} | ${status.in_air ? 'Airborne' : 'Grounded'}`);
        const battery_item = this.create_status_item('Battery:', `${status.battery.toFixed(2)}V | ${status.battery_remaining}%`);
        const lat_item = this.create_status_item('Latitude:', `${status.lat.toFixed(7)}`);
        const lon_item = this.create_status_item('Longitude:', `${status.lon.toFixed(7)}`);
        const alt_item = this.create_status_item('Altitude:', `${status.alt.toFixed(1)}m AGL | ${status.alt_abs.toFixed(1)}m MSL`);
        const heading_item = this.create_status_item('Heading:', `${status.heading.toFixed(1)} | yaw: ${status.yaw.toFixed(1)}`);
        const gps_item = this.create_status_item('GPS - # Sats:', `${status.gps_num_sats} | Fix: ${this.gpsFixType[status.gps_fix_type]} | HDOP: ${status.gps_hdop / 100}`);
        const taglock_item = this.create_status_item('Selected Taglock:', `${status.taglock.selected_taglock ? status.taglock.selected_taglock.data.name : 'None'} | Alert: ${status.taglock.selected_taglock ? status.taglock.selected_taglock.data.alert : 'None'}`);

        this.uav_status_el.appendChild(flight_mode_item);
        this.uav_status_el.appendChild(state_item);
        this.uav_status_el.appendChild(battery_item);
        this.uav_status_el.appendChild(lat_item);
        this.uav_status_el.appendChild(lon_item);
        this.uav_status_el.appendChild(alt_item);
        this.uav_status_el.appendChild(heading_item);
        this.uav_status_el.appendChild(gps_item);
        this.uav_status_el.appendChild(taglock_item);

        this.uav_drone_header_state_el.textContent = 'Connected';
        this.uav_drone_header_state_el.classList.remove('drone__status-header-state--disconnected');
      }
      else if (status.connected == false)
      {
        this.uav_status_el.innerHTML = '<span style="color: red;">Status: No Telemetry Data</span>';
        this.uav_drone_header_state_el.textContent = 'Disconnected';
        this.uav_drone_header_state_el.classList.add('drone__status-header-state--disconnected');
      }
      else
      {
        this.uav_status_el.innerHTML = status;
        this.uav_drone_header_state_el.textContent = 'No Data';
        this.uav_drone_header_state_el.classList.add('drone__status-header-state--white');
      }

      // Update button states based on flight mode from UAV
      // Guided = 4, brake = 17
      if (status.flight_mode == 17)
      {
        this.update_control_mode_button_state('brake');
      }
      else if (status.flight_mode == 4)
      {
        if (this.control_mode == 'taglock')
        {
          this.update_control_mode_button_state('taglock');
        }
        else
        {
          this.update_control_mode_button_state('guided');
        }
      }
      else
      {
        this.update_control_mode_button_state('other');
      }

      // Make armed button red if armed
      if (status.armed)
      {
        // this.btn_command_arm.addClass('drone__button-armed');
        $(this.btn_command_arm).addClass('drone__button-armed');
        $(this.btn_command_disarm).removeClass('drone__button-disarmed');
      }
      else
      {
        // this.btn_command_arm.removeClass('drone__button-armed');
        $(this.btn_command_arm).removeClass('drone__button-armed');
        $(this.btn_command_disarm).addClass('drone__button-disarmed');
      }
    }
  }

  update_precision_landing_connection_status(msg)
  {
    this.prec_land_connection_status_el.innerHTML = ` Connection Status: ${msg}`;
    this.prec_land_connection_status_el.classList.remove('hidden');
  }

  clear_uav_data()
  {
    this.uav_status_el.innerHTML = 'Waiting for data...';
  }

  add_message(text, severity = 6)
  {
    let text_color = '#ffffff';
    if (severity > 4)
    {
      // Info
      text_color = '#ffffff';
    }
    else if (severity == 4)
    {
      // Warning (orange)
      text_color = '#ffb500';
    }
    else
    {
      // Error or worse (red)
      text_color = '#ff0000';
    }
    this.uav_messages_el.innerHTML = `<span style="color: ${text_color}">${text}</span>` + '<br>' + this.uav_messages_el.innerHTML;
  }

  // Called from gui drone.pug
  clear_messages()
  {
    this.uav_messages_el.innerHTML = '';
  }

  show()
  {
  }

  hide()
  {
  }

  __on_mouse_down(e)
  {
    const origin = this.menu_handle.position().left;
    const touch = e.originalEvent.touches;
    const start = touch ? touch[0].pageX : e.pageX;

    $(window).on('mousemove touchmove', this.__on_mouse_move.bind(this, origin, touch, start));
    $(window).one('mouseup touchend', this.__on_mouse_up.bind(this));

    e.preventDefault();
  }

  __on_mouse_move(origin, touch, start, e)
  {
    const contact = e.originalEvent.touches;
    const end = touch ? contact[0].pageX : e.pageX;
    const difference = end - start;

    const newleft = Math.max(0, origin + difference);

    const newwidth = newleft + 35;

    this.menu_handle.css('left', newleft);
    this.container.css('width', newwidth);
  }

  __on_mouse_up(e)
  {
    e.preventDefault();
    $(window).off('mousemove touchmove');
    localStorage.setItem('drone_width', this.container.width());
  }

  __toggle_switch_elem(elem, should_activate)
  {
    if (should_activate)
    {
      $(elem).addClass('active');
    }
    else
    {
      $(elem).removeClass('active');
    }
  }
}

export default UavView;
